var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
		'image-icon': _vm.fillWithPrimary,
		'custom-icon': true,
	}},[_c('inline-svg',{attrs:{"width":_vm.sizeWidth,"height":_vm.sizeHeight,"src":require(`../assets/${_vm.file}.svg`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }